import { ModalCloseButton, ModalContentProps, useModalDismissHandler } from '~/common/components';
import { noop } from '~/common/utils';
import { LoginForm } from '~/components/forms/LoginForm';

export const LoginModal = ({
  onClose,
  onSuccess = noop,
  allowGuestCheckout = false,
}: {
  onSuccess?: () => void;
  allowGuestCheckout?: boolean;
} & ModalContentProps) => {
  useModalDismissHandler(onClose);
  return (
    <>
      <ModalCloseButton onClose={onClose} />
      <LoginForm
        className="p-3 w-[440px]"
        onSuccess={onSuccess}
        onClose={onClose}
        allowGuestCheckout={allowGuestCheckout}
      />
    </>
  );
};
